module.exports = __webpack_public_path__ + "img/consiliumbots.ba27401b.png";